import React, {Component} from 'react';
import {Breadcrumb, Button, Container} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import QuestionDialog from "../../components/extras/QuestionDialog";
import TicketExpirationDays from "../../components/services/TicketExpirationDays";
import TicketDialog from "../../components/services/TicketDialog";
import {ticketDialog} from "../../actions/TicketDialogActions";
import TicketData from "../../data/TicketData";
import TicketProductList from "../../components/services/TicketProductList";
import {selectTicket} from "../../actions/TicketSelectActions";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";
import StoreProfileData from "../../data/StoreProfileData";

class Tickets extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Nombre', 'Precio', 'Días de Caducidad', 'Productos', 'Acciones'],
                name: 'Tiquetera',
                title: 'Tiqueteras',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'tickets',
                values: ['id', 'name', 'price', 'has_expiration', 'products'],
                money_fields: ['price'],
                component_fields:[{has_expiration:  TicketExpirationDays, products:  TicketProductList,}],
                id: 'table_tickets'
            },
            ticket_service: localDB.get('store_settings').ticket_service,
            sending: false
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.ticket_select && nextProps.ticket_select.id){
            this.props.dynamicTableAddOrUpdate(nextProps.ticket_select);
        }
    }

    delete = (id) => {
        TicketData.delete(id, (res) => {
            if (res === null) {
                this.props.dynamicTableDelete(id);
                this.props.showToast({message: 'Tiquetera Borrada!', type: 'success'});
            } else {
                this.props.showToast({message: 'Esta tiquetera está siendo usada, por favor marcarla como inactiva', type: 'error'});
            }
        });
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.selectTicket({id:null, name:' ', price:0, has_expiration:false, expiration_days:0, products:[]});
            this.props.ticketDialog({open: true, ticket:{id:null, name:' ', price:0, has_expiration:false, expiration_days:0}});
        }else if(response.event === 'edit'){
            this.props.selectTicket(response.data);
            this.props.ticketDialog({open:true, ticket:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }
    };

    handleActiveService = () => {
        this.setState({sending:true});
        StoreProfileData.ticketService({ticket_service: !this.state.ticket_service}, res =>{
          if(res && res.update){
              let store_settings = localDB.get('store_settings');
              this.setState({ticket_service: !this.state.ticket_service});
              store_settings.ticket_service = !store_settings.ticket_service;
              localDB.set('store_settings', store_settings);
              this.props.showToast({open:true, message:`Servicio ${this.state.ticket_service ? 'Activo':'Inactivo'}`, type:'success'});
          }else {
              this.props.showToast({open:true, message:'Tenemos un problema', type:'success'});
          }
      }).catch(() => {
            this.props.showToast({open:true, message:'Tenemos un problema', type:'success'});
        }).finally(() => {
            this.setState({sending:false});
        });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Tiqueteras | Servicios - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/services'>Servicios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Tiquetera</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {localDB.checkPlanAccessExclude('ticket_service') ?
                    <UpgradeAccount/>:
                    this.state.ticket_service ?
                        <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>:null
                }
                {!localDB.checkPlanAccessExclude('ticket_service') ? <Container textAlign='center'>
                    <br/>
                    <Button
                        size='large' icon='rocket'
                        onClick={this.handleActiveService}
                        labelPosition='left'
                        loading={this.state.sending}
                        disabled={this.state.sending}
                        primary content={`${this.state.ticket_service ? 'Inactivar':'Activar'} Servicio de Tiquetera`}
                    />
                </Container>:null}
                {!localDB.checkPlanAccessExclude('ticket_service') ? <TicketDialog />:null}
                {!localDB.checkPlanAccessExclude('ticket_service') ? <QuestionDialog ref="deleteDialog" message="Borrar esta tiquetera" callbackConfirm={this.delete}/>:null}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ticket_select: state.get('ticket_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        ticketDialog(data) {
            dispatch(ticketDialog(data));
        },
        selectTicket(data) {
            dispatch(selectTicket(data));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Tickets)



// WEBPACK FOOTER //
// ./src/containers/services/Tickets.js